<app-landing-toolbar *ngIf="authService.currentUserId === 'anonymous'"></app-landing-toolbar>
<div class="wrapper" [ngClass]="authService.currentUserId === 'anonymous' ? 'main-substitution' : ''">
    <div class="search-and-pages">
        <app-advanced-search class="search" [columns]="searchColumns" (newQuery)="newQuery($event)"></app-advanced-search>
        <div class="sort">
            <mat-form-field>
                <mat-label>Sort by</mat-label>
                <mat-select [formControl]="sortFieldCtl">
                    <mat-option *ngFor="let field of searchColumns" [value]="field">{{field.title}}</mat-option>
                </mat-select>
            </mat-form-field>
            <button mat-icon-button (click)="toggleDirection()">
                <mat-icon *ngIf="asc">arrow_drop_up</mat-icon>
                <mat-icon *ngIf="!asc">arrow_drop_down</mat-icon>
            </button>
        </div>
        <mat-paginator class="pages" *ngIf="decksWithTotalCount" [length]="decksWithTotalCount.totalCount"
                       [pageSizeOptions]="pageSizeOptions"
                       [pageIndex]="defaultPageIndex"
                       [pageSize]="defaultPageSize"
                       showFirstLastButtons
                       (page)="newPage($event)"></mat-paginator>
    </div>
    <app-pretty-deck-list *ngIf="decksWithTotalCount" [decks]="decksWithTotalCount.decks" [add]="false" [isPublicView]="true"></app-pretty-deck-list>
    <mat-progress-bar *ngIf="isLoadingResults" mode="query"></mat-progress-bar>
</div>